import { useLocale, useTranslate } from '@va/localization';
import { ConfirmationDialogType, ConfirmationModal } from '@va/shared/util-confirmation';
import { addNumberSeparator } from '@va/util/helpers';

export const getDeleteMultipleRecordingsConfirmationDialog =
  (count: number): ConfirmationDialogType =>
  ({ onClose, onConfirm }) => {
    const translate = useTranslate();
    const { locale } = useLocale();

    return (
      <ConfirmationModal
        title={translate('recordings.actions.multiple.delete')}
        isOpen={true}
        onConfirmation={onConfirm}
        onClose={onClose}
        info={translate('recordings.actions.info.multiple.delete', { count: addNumberSeparator(count, locale) })}
      />
    );
  };
